import { ofType } from 'redux-observable-es6-compat';
import { catchError, filter, map, mergeMap, tap } from 'rxjs/operators';

import { AFetchBlacklist, ASetBlacklist, IFetchBlacklist, TBlacklist, TRemote } from '../actions';
import { of } from 'rxjs';

const fetchBlacklistListeners = [
  TBlacklist.FETCH_BLACKLIST,
  TRemote.SET_REMOTE,
  // TPlayer.SET_PLAYER_STATUS
];
export const fetchBlacklistEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => fetchBlacklistListeners.includes(type)),
    mergeMap(() => restApi.get('/blacklist?ngsw-bypass=true').pipe(
      /**
       * There is a common handler for all errors.
      * However, we need to return an empty array in case of an error
      * to prevent the error from being propagated to the upper level.
      * If it is not handled here, this interrupts the flow if the API returns a 404.
       */
      catchError(() => of([])),
    )),
    map(ASetBlacklist)
  );

export const removeBlacklistEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TBlacklist.UNBLACKLIST),
    mergeMap(({ payload }) => restApi.delete(`/blacklist/${payload}?ngsw-bypass=true`).pipe(
      catchError(() => of(AFetchBlacklist())),
    )),
    filter((action: IFetchBlacklist | any) => action?.type === TBlacklist.FETCH_BLACKLIST),
  );

export const addBlacklistEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TBlacklist.BLACKLIST),
    mergeMap(({ payload }) => restApi.put(`/blacklist/${payload.id}?ngsw-bypass=true`).pipe(
      catchError(() => of(AFetchBlacklist())),
    )),
    filter((action: IFetchBlacklist | any) => action?.type === TBlacklist.FETCH_BLACKLIST),
  );
